import { render, staticRenderFns } from "./RelacaoLicitantesSgtec.vue?vue&type=template&id=970f8ea0"
import script from "./RelacaoLicitantesSgtec.vue?vue&type=script&lang=js"
export * from "./RelacaoLicitantesSgtec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports